import BackArrow from '@public/images/backArrowMobile.svg';
import { getDomainOrigin } from '@utils/serverConfig';
import { Wrapper } from './styles';

interface IProps {
    policyid: string;
}

function header({ policyid }: IProps) {
    const onBack = () => {
        window.location.href = `${getDomainOrigin()}/partnership/policy?policyid=${policyid}`;
    };
    return (
        <Wrapper>
            <BackArrow onClick={onBack} />
        </Wrapper>
    );
}

export default header;
